export type AuthTokens = { accessToken: string; refreshToken: string; accessTokenExpiresAt?: number }

export const ACCESS_TOKEN_KEY = 'access_token'
export const REFRESH_TOKEN_KEY = 'refresh_token'
export const ACCESS_TOKEN_EXPIRES_AT_KEY = 'access_token_expires_at'
export const AUTH_TOKENS_UPDATED_EVENT = 'auth_tokens_updated'

export function getStoredTokens(): AuthTokens {
  if (typeof window === 'undefined') return { accessToken: '', refreshToken: '' }
  const ls = window.localStorage
  const ss = window.sessionStorage
  const accessToken = ls.getItem(ACCESS_TOKEN_KEY) || ss.getItem(ACCESS_TOKEN_KEY) || ''
  const refreshToken = ls.getItem(REFRESH_TOKEN_KEY) || ss.getItem(REFRESH_TOKEN_KEY) || ''
  const expiresAtRaw = ls.getItem(ACCESS_TOKEN_EXPIRES_AT_KEY) || ss.getItem(ACCESS_TOKEN_EXPIRES_AT_KEY) || ''
  const expiresAt = expiresAtRaw ? Number(expiresAtRaw) : 0
  const accessTokenExpiresAt = Number.isFinite(expiresAt) && expiresAt > 0 ? Math.round(expiresAt) : undefined
  return { accessToken, refreshToken, accessTokenExpiresAt }
}

function removeLocalStorageKeys(prefixes: string[], exactKeys: string[]) {
  try {
    for (const k of exactKeys) {
      try {
        window.localStorage.removeItem(k)
      } catch {}
    }
  } catch {}
  try {
    const keys: string[] = []
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const k = window.localStorage.key(i)
      if (k) keys.push(k)
    }
    for (const k of keys) {
      if (prefixes.some((p) => k.startsWith(p))) {
        try {
          window.localStorage.removeItem(k)
        } catch {}
      }
    }
  } catch {}
}

function cleanupStorageForAuthTokens() {
  removeLocalStorageKeys(['vg_task_thumb_v1:'], ['video_tasks_v1'])
}

function writeTokensToStorage(storage: Storage, next: AuthTokens) {
  storage.setItem(ACCESS_TOKEN_KEY, next.accessToken || '')
  storage.setItem(REFRESH_TOKEN_KEY, next.refreshToken || '')
  if (next.accessTokenExpiresAt) storage.setItem(ACCESS_TOKEN_EXPIRES_AT_KEY, String(next.accessTokenExpiresAt))
  else storage.removeItem(ACCESS_TOKEN_EXPIRES_AT_KEY)
}

export function setStoredTokens(tokens: Partial<AuthTokens>) {
  if (typeof window === 'undefined') return
  const prev = getStoredTokens()
  const next: AuthTokens = {
    accessToken: tokens.accessToken !== undefined ? tokens.accessToken : prev.accessToken,
    refreshToken: tokens.refreshToken !== undefined ? tokens.refreshToken : prev.refreshToken,
    accessTokenExpiresAt: tokens.accessTokenExpiresAt !== undefined ? tokens.accessTokenExpiresAt : prev.accessTokenExpiresAt,
  }
  let storedOk = false
  try {
    writeTokensToStorage(window.localStorage, next)
    storedOk = true
  } catch {
    cleanupStorageForAuthTokens()
    try {
      writeTokensToStorage(window.localStorage, next)
      storedOk = true
    } catch {}
  }
  if (!storedOk) {
    try {
      writeTokensToStorage(window.sessionStorage, next)
    } catch {}
  } else {
    try {
      window.sessionStorage.removeItem(ACCESS_TOKEN_KEY)
      window.sessionStorage.removeItem(REFRESH_TOKEN_KEY)
      window.sessionStorage.removeItem(ACCESS_TOKEN_EXPIRES_AT_KEY)
    } catch {}
  }
  try {
    window.dispatchEvent(new CustomEvent(AUTH_TOKENS_UPDATED_EVENT, { detail: next }))
  } catch {}
}

export function clearStoredTokens() {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.removeItem(ACCESS_TOKEN_KEY)
    window.localStorage.removeItem(REFRESH_TOKEN_KEY)
    window.localStorage.removeItem(ACCESS_TOKEN_EXPIRES_AT_KEY)
  } catch {}
  try {
    window.sessionStorage.removeItem(ACCESS_TOKEN_KEY)
    window.sessionStorage.removeItem(REFRESH_TOKEN_KEY)
    window.sessionStorage.removeItem(ACCESS_TOKEN_EXPIRES_AT_KEY)
  } catch {}
  try {
    window.dispatchEvent(
      new CustomEvent(AUTH_TOKENS_UPDATED_EVENT, { detail: { accessToken: '', refreshToken: '', accessTokenExpiresAt: undefined } }),
    )
  } catch {}
}
